import React from 'react';
const SvgCheckmark = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 32 32", focusable: false }, props),
    React.createElement("path", { d: "M12.216 27.016L0 14.168l2.91-2.77 9.346 9.837L29.129 4 32 6.8z", fillRule: "evenodd" })));
export default SvgCheckmark;
//# sourceMappingURL=Checkmark.js.map